<template>
  <button
    :class="[
      $style.button,
      small && $style.small,
      transparent && $style.transparent,
      back && $style.back,
      grayscale && $style.grayscale,
    ]"
    :disabled="disabled"
    :type="type"
  >
    <slot />
  </button>
</template>

<style lang="scss" module>
.button {
  font-size: 1.8rem;
  font-weight: bold;
  padding: 12px 36px;
  cursor: pointer;
  letter-spacing: 1.1px;
  color: #fff;
  border: solid 1px #fff8fb;
  border-radius: 6px;
  outline: none;
  background-color: #e73273;
  transition: background-color 0.2s;

  &.small {
    padding: 10px 20px;
    font-size: 1.4rem;
  }

  &.transparent {
    background: transparent;
    color: $red;
  }

  &.grayscale {
    filter: grayscale(1);
  }

  &.back {
    background-color: white;
    color: #e73273;
    border: none;
  }

  &.back:active,
  &.back:hover:enabled {
    background-color: white;
  }

  &:disabled {
    border-color: #fff8fb;
    background-color: rgba(231, 50, 115, 0.3);
  }

  &:active,
  &:hover:enabled {
    background-color: #fadce2;
  }
}
</style>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    back: {
      type: Boolean,
      default: false,
    },
    grayscale: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
